export default {
  badge: 'Odznaka',
  open: 'Otwórz',
  close: 'Zamknij',
  confirmEdit: {
    ok: 'OK',
    cancel: 'Anuluj',
  },
  dataIterator: {
    noResultsText: 'Nie znaleziono danych odpowiadających wyszukiwaniu',
    loadingText: 'Wczytywanie danych...',
  },
  dataTable: {
    itemsPerPageText: 'Wierszy na stronie:',
    ariaLabel: {
      sortDescending: 'Sortowanie malejąco. Kliknij aby zmienić.',
      sortAscending: 'Sortowanie rosnąco. Kliknij aby zmienić.',
      sortNone: 'Bez sortowania. Kliknij aby posortować rosnąco.',
      activateNone: 'Kliknij aby usunąć sortowanie.',
      activateDescending: 'Kliknij aby posortować malejąco.',
      activateAscending: 'Kliknij aby posortować rosnąco.',
    },
    sortBy: 'Sortuj według',
  },
  dataFooter: {
    itemsPerPageText: 'Pozycji na stronie:',
    itemsPerPageAll: 'Wszystkie',
    nextPage: 'Następna strona',
    prevPage: 'Poprzednia strona',
    firstPage: 'Pierwsza strona',
    lastPage: 'Ostatnia strona',
    pageText: '{0}-{1} z {2}',
  },
  dateRangeInput: {
    divider: 'do',
  },
  datePicker: {
    itemsSelected: '{0} selected',
    range: {
      title: 'Wybór zakresu dat',
      header: 'Wprowadź zakres dat',
    },
    title: 'Wybór daty',
    header: 'Wprowadź datę',
    input: {
      placeholder: 'Wprowadź datę',
    },
  },
  noDataText: 'Brak danych',
  carousel: {
    prev: 'Poprzedni obraz',
    next: 'Następny obraz',
    ariaLabel: {
      delimiter: 'Obraz {0} z {1}',
    },
  },
  calendar: {
    moreEvents: '{0} więcej',
  },
  input: {
    clear: 'Wyczyść {0}',
    prependAction: '{0} dodatkowa akcja',
    appendAction: '{0} dodatkowa akcja',
    otp: 'Proszę wprowadzić znak nr {0}',
  },
  fileInput: {
    counter: 'Liczba plików: {0}',
    counterSize: 'Liczba plików: {0} (łącznie {1})',
  },
  timePicker: {
    am: 'AM',
    pm: 'PM',
  },
  pagination: {
    ariaLabel: {
      root: 'Nawigacja paginacyjna',
      next: 'Następna strona',
      previous: 'Poprzednia strona',
      page: 'Idź do strony {0}',
      currentPage: 'Bieżąca strona, strona {0}',
      first: 'Pierwsza strona',
      last: 'Ostatnia strona',
    },
  },
  stepper: {
    next: 'Następny',
    prev: 'Poprzedni',
  },
  rating: {
    ariaLabel: {
      item: 'Ocena {0} na {1}',
    },
  },
  loading: 'Wczytywanie danych...',
  infiniteScroll: {
    loadMore: 'Wczytaj więcej',
    empty: 'Brak kolejnych danych',
  },
}
